import React, { Component } from 'react'
import { 
  Button, ButtonGroup, Popover,
  Menu, MenuItem, Position
} from '@blueprintjs/core';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import ClientAutocomplete from 'components/ClientAutocomplete';
import LocationPicker from 'components/LocationPicker';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';
import MoveEquipmentPanel from 'components/Equipment/MoveEquipmentPanel';

@inject('store', 'viewStore', 'equipmentStore') @observer
class Equipment extends Component {

  @observable selectedClient = '';
  @observable showLocationFilter = false;
  @observable isMoveEquipmentOpen = false;

  @action
  onClientSelect(client) {
    let {
      props: {
        viewStore: {
          equipmentSearch
        }
      }
    } = this;
    if (client) {
      this.props.viewStore.equipmentSearch = {
        ...equipmentSearch,
        where: {
          ...equipmentSearch.where,
          client_id: client.id
        }
      }
      this.showLocationFilter = true;
    } else {
      this.props.viewStore.equipmentSearch = {
        ...equipmentSearch,
        where: {
          location_id: ""
        }
      }
      this.showLocationFilter = false;
    }
  }

  onLocationChange(locations) {
    let selectedValues = locations.map((location) => location.value);
    let {
      props: {
        viewStore: {
          equipmentSearch
        }
      }
    } = this;
    this.props.viewStore.equipmentSearch = {
      ...equipmentSearch,
      where: {
        ...equipmentSearch.where,
        location_id: selectedValues
      }
    }
  }

  // Text search over type, make, model, serial number, equipment location and
  // description (the API's equipment search). Empty means everything ("*").
  @action
  onTermChange(event) {
    const { viewStore } = this.props;
    viewStore.equipmentSearch = {
      ...viewStore.equipmentSearch,
      term: event.target.value.trim() || '*'
    };
  }

  onTermKeyPress(event) {
    if (event.key === 'Enter') this.search();
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.equipmentSearch.page = 1;
    viewStore.equipments();
  }

  download_bulk_excel() {
    this.props.equipmentStore.download_bulk_excel(this.props.viewStore.equipmentSearch)
  }

  openMoveEquipment() {
    this.isMoveEquipmentOpen = true;
  }

  closeMoveEquipment() {
    this.isMoveEquipmentOpen = false;
  }

  // The moved equipment may have filled the page being shown, so go back to
  // page 1 (through the URL, like Search) rather than reload an empty page.
  @action
  onMoveEquipmentSuccess() {
    const { viewStore, equipmentStore } = this.props;
    this.isMoveEquipmentOpen = false;
    const onFirstPage = !viewStore.equipmentSearch.page || Number(viewStore.equipmentSearch.page) === 1;
    viewStore.equipmentSearch.page = 1;
    viewStore.equipments();
    // Same address as before, so the router won't reload the list itself.
    if (onFirstPage) equipmentStore.loadEquipments();
  }

  render() {
    let {
      props: {
        viewStore: {
          equipmentSearch: {
            where,
            term
          }
        }
      }
    } = this
    where = toJS(where);
    return (
      <React.Fragment>
        <SearchFiltersToolbar
          searchButton={
            <SearchFiltersSearchButton onClick={this.search.bind(this)} />
          }
          actions={
            <Popover
              minimal={true}
              content={
                <Menu>
                  <MenuItem text="Move equipment to another client" onClick={this.openMoveEquipment.bind(this)} />
                  <MenuItem text="Download Excel/CSV" onClick={this.download_bulk_excel.bind(this)}/>
                </Menu>
              }
              position={Position.BOTTOM_LEFT}
              usePortal={true}>
              <Button rightIcon='caret-down'>
                Options
              </Button>
            </Popover>
          }
        >
          <input
            type="search"
            className="bp3-input input-control search-filters-toolbar__field-wide"
            placeholder="Serial number, make, model or location"
            aria-label="Search equipment"
            defaultValue={term && term !== '*' ? term : ''}
            onChange={this.onTermChange.bind(this)}
            onKeyPress={this.onTermKeyPress.bind(this)}
          />

          <ClientAutocomplete
            selectedClientId={where && where.client_id}
            inputProps={{ placeholder: 'Select client', leftIcon: 'person', 'aria-label': 'Client' }}
            onClientSelect={this.onClientSelect.bind(this)}
          />

          {this.showLocationFilter && <LocationPicker
            selectedOptions={(where && where.location_id) || []}
            onChange={this.onLocationChange.bind(this)}
          />}
        </SearchFiltersToolbar>
        <MoveEquipmentPanel
          isOpen={this.isMoveEquipmentOpen}
          sourceClientId={where && where.client_id}
          onClose={this.closeMoveEquipment.bind(this)}
          onSuccess={this.onMoveEquipmentSuccess.bind(this)}
        />
      </React.Fragment>
    )
  }

}

export default Equipment;